import React from "react";
import { ShortcutKeys } from "../../shortcuts/Kbd";
import { H, Note, P, Term } from "./elements";

export const SkillsArticle: React.FC = () => (
  <>
    <P>
      <Term>Skills</Term> determine what you know how to build.{" "}
      <Term>Reputation</Term> determines who's willing to hire you. They're
      earned separately and unlock different things.
    </P>

    <H>XP and Skill Points</H>
    <P>
      Craft XP comes from completed work: finishing a product earns XP equal to
      its value. Each level grants one <Term>skill point</Term> to spend in the
      tree in your journal (<ShortcutKeys shortcut="open-journal" /> or the
      Skills button up top). The bar under that button fills as you earn XP
      toward the next point.
    </P>

    <H>The Skill Tree</H>
    <P>
      Every recipe belongs to a skill. The bench offers only the recipes you've
      learned; the rest can be previewed in the tree. Some nodes unlock new
      recipes; others speed up work you already do, like faster sanding or
      quicker glue cures.
    </P>

    <H>Reputation</H>
    <P>
      Reputation comes from selling work off the stand. It opens the
      lumberyard's racks in turn, first S2S and later cheap rough-sawn stock.
    </P>

    <Note>XP scales with value — bigger pieces level you fastest.</Note>
  </>
);
